import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import styled from 'styled-components';
import { AuthState, withAuth } from 'context/auth';
import { AlertsState, withAlerts } from 'context/alerts';
import { LoadingDots } from 'components';
import { getSandboxTerms } from 'utils/api';

const StyledHeader = styled.h3`
  margin-top: 0;
`;
interface Props {
  auth: AuthState;
  alerts: AlertsState;
  loadTermsOnInit: boolean;
  children?: React.ReactNode;
}

const SandboxTermsWrapper = (props: Props) => {
  const [termsTitle, setTermsTitle] = useState('');
  const [terms, setTerms] = useState('');
  const [termsLoading, setTermsLoading] = useState(false);

  useEffect(() => {
    if (
      props.auth.sandbox?.termsAccepted === false ||
      props.loadTermsOnInit === true
    ) {
      setTermsLoading(true);
      loadTerms();
    }
  }, []);

  const loadTerms = async () => {
    try {
      const terms = await getSandboxTerms(props.auth, props.auth.sandbox?.id);

      setTermsTitle(terms.title);

      setTerms(terms.body);
      setTermsLoading(false);
    } catch (err: any) {
      setTermsLoading(false);
      props.alerts.setMessage(err, 'danger');
    }
  };

  if (termsLoading)
    return <LoadingDots dotColor="white">Loading sandbox terms</LoadingDots>;

  return (
    <>
      {!props.loadTermsOnInit && (
        <StyledHeader>Accept the Terms of Use to continue</StyledHeader>
      )}
      <h4>{termsTitle}</h4>
      <ReactMarkdown>{terms}</ReactMarkdown>
      {props.children}
    </>
  );
};

const SandboxTerms = withAuth(withAlerts(SandboxTermsWrapper));

export { SandboxTerms };
